import { put, select, takeLatest } from 'redux-saga/effects';
import { clearCompletedQueue, appNotify, fetchQueueTxnOppsData } from 'store/actions';
import { showPostAcquisitionsSelector } from 'store/selectors';
import { postWithTokenV2 } from 'api/network';
import { Constants } from 'utilities/constants';

export function* clearCompletedQueueSaga() {
  yield takeLatest(clearCompletedQueue, function* ({ payload: module }) {
    try {
      if (module === Constants.Module.UNDERWRITE) {
        const showPostAcquisitions = yield select(showPostAcquisitionsSelector)
        const url = '/api/underwrite/workflow/tasks/clearCompleted';
        const clearCompletedTasksRequest = { clearPostAcquisitions: showPostAcquisitions }
        yield postWithTokenV2(url, clearCompletedTasksRequest);
      } else if (module === Constants.Module.POSTACQ) {
        const url = '/api/postAcquisition/tasks/clearCompleted';
        yield postWithTokenV2(url);
      }
      yield put(fetchQueueTxnOppsData(module));
    } catch (error) {
      yield put(appNotify(`Failed completed tasks request: ${error.message}`, 'error'));
    }
  });
}